import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-bounced-message',
  template: `
  <div style="float: left; margin-right: 10px; transform: translate(0px, -5px);">
    <mat-icon>email</mat-icon>
  </div>
  <div class="description">
    <strong>Undelivered Message</strong>
    <div class="text">
      to {{ activity.meta['recipient'].email }}
    </div>
    <span class="info">
      <span class="options">
        <a *ngIf="borrower.status !== 'doNotContact'"
          [routerLink]="'borrower/' + this.activity.borrowerId" [queryParams]="{pane: 'messages', subpane: 'email'}">View</a>
      </span>
    </span>

  </div>
  `,
  styles: [],
  standalone: false
})
export class ActivityRowBouncedMessageComponent {
  @Input() activity;
  @Input() borrower;
}
